var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_03_wideo",
    "data-name": "03_wideo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(36.574 8.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M662.7,1064.287l-73.288-42.611V980.25l73.254,42.293",
    transform: "translate(-587.642 -924.679)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M617.008,813.247,562.23,781.629V768.89",
    transform: "translate(-562.23 -727.068)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M615.618,727.57l-46.586-26.89-6.8,4.437",
    transform: "translate(-562.23 -663.296)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M1722.348,1572.89v41.785l-6.328,3.7",
    transform: "translate(-1640.964 -1478.767)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M1424.544,1230.736h0c-10.448-6.032-20.244,1.915-20.244,12.363h0l20.244,11.685",
    transform: "translate(-1349.522 -1156.92)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4537",
    "data-name": "Path 4537",
    d: "M678.819,264.462l-58.339-59.1,3.284-9.483",
    transform: "translate(-616.691 -191.334)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4538",
    "data-name": "Path 4538",
    d: "M746.739,195.2l-68.2-69.212-7.578,4.546",
    transform: "translate(-663.887 -125.99)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 61.658,
    y2: 35.968,
    transform: "translate(7.583 75.808)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 16.06,
    transform: "translate(27.558 87.797)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y2: 16.06,
    transform: "translate(48.018 99.786)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4539",
    "data-name": "Path 4539",
    d: "M1715.5,1218.593l7.83-4.6V1189.94l-7.83,4.6",
    transform: "translate(-1640.478 -1120.728)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 156,
    height: 156,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.d04a97ed9a35b0308d1925982d6b6bd7.svg";
export { ForwardRef as ReactComponent };